import { ACCOUNT_SERVER } from '../abs/config/api';
import qs from 'qs';
/**
 * 权限业务封装
 */
export default class WechatUtil {
  static appid = 'wx93e60a944c261a3c';

  /**
   * 获取登录地址
   * @returns {string} 登录地址
   */
  static getLoginUrl = () => {
    const domain = 'https://open.weixin.qq.com/connect/qrconnect';
    const scope = 'snsapi_login';
    const redirectUri = 'https://www.cn-abs.com/account.html';
    const href = `https://www.cn-abs.com/wechat.css?timestamp=${new Date().getTime()}`;

    return `${domain}?appid=${WechatUtil.appid}&response_type=code&scope=${scope}&redirect_uri=${redirectUri}&href=${href}`;
  };

  static getExternalURL = () => {
    let params = qs.parse(location.search.split('?')[1]);
    return `${ACCOUNT_SERVER}/external/challenge?provider=WeChat&returnUrl=${encodeURIComponent(params.return_url || '')}`;
  };

  /**
   * 获取绑定微信号地址
   * @returns {string} 绑定微信号地址
   */
  static getBindUrl = () => {
    const domain = 'https://open.weixin.qq.com/connect/qrconnect';
    const scope = 'snsapi_login';
    const redirectUri = 'https://www.cn-abs.com/message.html';
    const href = `https://www.cn-abs.com/wechat.css?timestamp=${new Date().getTime()}`;

    return `${domain}?appid=${WechatUtil.appid}&response_type=code&scope=${scope}&href=${href}&redirect_uri=${redirectUri}`;
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/wechatUtil.ts